<template>
  <div>
    <div class="location">
      当前位置：
      <router-link :to="{ path: '/' }" class="a">首页</router-link
      >&nbsp;&gt;&nbsp;
      <a class="a" href="javascript:;">{{ currentFieldname }}</a>
    </div>
    <div></div>
    <div v-for="itemChild in docsData" :key="itemChild.reportName">
      <div v-if="itemChild.data">
        <div class="title_qb clearfix">
          <a href="javascript:;" class="fl cursor">
            <h2>{{ itemChild.reportName }}</h2>
          </a>
          <router-link
            class="fr"
            :to="{
              path: '/allReport',
              query: {
                id: currentId,
                idname: currentFieldname,
                uid: itemChild.reportName,
              },
            }"
          >
            <span class="more">更多&gt;&gt;</span>
          </router-link>
        </div>
        <ul class="qb_main_ul">
          <li v-for="item in itemChild.data" :key="item.code" class="clearfix">
            <a
              :href="
                indexLinkURL +
                '/eDRCnet.common.web/DocDetail.aspx?chnid=' +
                item.chnid +
                '&leafid=' +
                item.leafid +
                '&docid=' +
                item.code.substring(4, item.code.length) +
                '&uid=' +
                item.uid +
                '&version=dReport'
              "
              target="_blank"
              class="fl"
            >
              <span class="d_icon">·</span>
              <span>{{ item.title }}</span>
            </a>
            <span class="fr time">{{ item.deliveddate }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/pages/index/require/api.js";
export default {
  data() {
    return {
      currentReportUid: "",
      currentId: "",
      currentFieldname: "",
      docsData: [],
      indexLinkURL: window.indexLinkURL,
    };
  },
  created() {
    this.$route.query.uid === undefined
      ? (this.currentReportUid = "")
      : (this.currentReportUid = this.$route.query.uid);
    this.$route.query.id === undefined
      ? (this.currentId = "90")
      : (this.currentId = this.$route.query.id);
    this.currentFieldname = this.$route.query.idname;
    this.loadDocs();
  },
  watch: {
    $route() {
      this.$route.query.uid === undefined
        ? (this.currentReportUid = "")
        : (this.currentReportUid = this.$route.query.uid);
      this.$route.query.id === undefined
        ? (this.currentId = "90")
        : (this.currentId = this.$route.query.id);
      this.currentFieldname = this.$route.query.idname;
      this.loadDocs();
    },
  },
  methods: {
    async loadDocs() {
      const { code, data } = await api.get("/indexController/getIndexDocs", {
        uid: this.currentId,
        reportType: this.currentReportUid,
        currpage: 1,
        pagesize: 17,
        isIndexSearch: false,
        time: new Date().getTime(),
      });
      this.docsData = [];
      if (code === 0) {
        for (let key in data) {
          if (key === "monthreport")
            (data[key].reportName = "月度报告"),
              (data[key].name = "weekReport");
          if (key === "weekreport")
            (data[key].reportName = "周评"), (data[key].name = "weekReport");
          if (key === "yearreport")
            (data[key].reportName = "年度报告"),
              (data[key].name = "yearReport");
          if (key === "quarterreport")
            (data[key].reportName = "季度报告"),
              (data[key].name = "weekReport");
          if (key === "hotreport")
            (data[key].reportName = "热点报告"),
              (data[key].name = "weekReport");
        }
        this.docsData.push(data.weekreport);
        this.docsData.push(data.hotreport);
        this.docsData.push(data.monthreport);
        this.docsData.push(data.quarterreport);
        this.docsData.push(data.yearreport);
        console.log(this.docsData, "this.docsData");
      }
    },
  },
};
</script>

<style lang='less' scoped>
.title_qb {
  margin-top: 5px;
  margin-left: 10px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 15px;
  h2 {
    font-size: 16px;
    border-bottom: 2px solid #0770b9;
    line-height: 30px;
    display: inline-block;
    padding: 5px;
    color: #0770b9;
    font-weight: 600;
    position: relative;
    bottom: -1px;
  }
  .more {
    line-height: 30px;
    font-size: 14px;
    color: #999;
    padding-top: 10px;
    display: block;
  }
}
.qb_main_ul {
  margin-left: 11px;
  margin-top: 15px;
  li {
    line-height: 30px;
    a {
      font-size: 15px;
      color: #333;
      display: block;
      width: 80%;
      overflow: hidden;
      -o-text-overflow: ellipsis;
      text-overflow: ellipsis;
      white-space: nowrap;
      .d_icon {
        font-size: 14px;
        font-weight: bold;
        color: #caccce;
        padding-right: 5px;
      }
    }
    .time {
      color: #666;
    }
  }
  li:nth-child(6n) {
    margin-top: 25px;
  }
  li:hover a,
  li:hover .time {
    color: #0770b9;
  }
}
</style>